import React, { useEffect } from "react";
import { Autocomplete, Button, Grid, Paper, Toolbar } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import CommonForm from "../../utils/components/commonForm";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { BASE_URL } from "../../global";

const EditCircle = () => {
  const [inputStates, setInputStates] = React.useState({});
  const params = useParams();

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const handleSubmit = () => {
    let url = BASE_URL;
    if (params.id) {
      axiosWithToken
        .patch(url + `circles/${params.id}`, inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Circle edit successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    } else {
      axiosWithToken
        .post(url + "circles", inputStates)
        .then((res) => {
          setTimeout(refresh, 500);
          toast("Circle created successfully !");
        })
        .catch((error) => {
          toast.error("Something Went Wrong!");
        });
    }
  };

  const fetchCircles = (inpt) => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `circles/${params.id}`)
      .then((res) => {
        let dataObject = res.data[0];

        let newData = {
          ...inputStates,
          ...dataObject,
        };
        dataObject && setInputStates(newData);
      })
      .catch((error) => {
        toast.error("Something Went Wrong!");
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    if (params.id) fetchCircles();
  }, [params.id]);

  const inputFields = [
     {
      type: "Autocomplete",
      label: "Client Name",
      stateKey: "clientId",
      valueKey: "id",
      options: "clients",
      getOptionLabelKey: "name",
    },
    { type: "TextField", label: "Name", stateKey: "name" },
    {
      type: "Autocomplete",
      label: "Alloted",
      stateKey: "alloted",
      valueKey: "id",
      options: [
        { id: 0, name: "No" },
        { id: 1, name: "Yes" },
      ],
      getOptionLabelKey: "name",
    },
  ];

  return (
    <>
      <Paper sx={{ mt: 2, p: 4 }}>
        <CommonForm
          inputStates={inputStates}
          updateInputObject={updateInputObject}
          inputFields={inputFields}
        />

        <Toolbar
          style={{
            padding: "0px",
            overflow: "auto",
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            onClick={() => {
              handleSubmit();
            }}
          >
            {params.id ? "Update" : "Save"}
          </Button>
        </Toolbar>
      </Paper>
    </>
  );
};

export default EditCircle;
